module.exports = __webpack_public_path__ + "static/media/dental_placeholder.3afa1bfd.png";